<template>
    <v-app>
        <Header/>
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
        <FooterMobile/>
    </v-app>
</template>

<script>
    import Header from "@/components/base/axa/Header";
    import FooterMobile from "@/components/base/axa/Footer-mobile";

    export default {
        name: "masterMobileAXA",
        components: {
            Header,
            FooterMobile,
        },
        data() {
            return {
                idSession: sessionStorage.getItem('sessionId'),
            };
        },
    };
</script>
